<div class="grid-container" [style.height]="this.gridHeight">
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-theme-skin"
    [ngClass]="this.getRowModelType()"
    [components]="this.components"
    [rowHeight]="this.rowHeight"
    [rowModelType]="this.getRowModelType()"
    [loadingCellRenderer]="this.loadingCellRenderer"
    [noRowsOverlayComponent]="this.noRowsOverlayComponent"
    (gridReady)="this.isReady($event)"
    [suppressPaginationPanel]="true"
    [pagination]="this.gridOptions().pagination ?? false"
    [paginationAutoPageSize]="this.paginationAutoPageSize() && this.displayType() === 'grid'"
    [paginationPageSize]="this.gridOptions().paginationPageSize ?? 10"
  >
  </ag-grid-angular>
</div>

@if (this.displayType() === 'table') {
  <cam-grid-table
    [gridId]="this.gridId()"
    [autoPageSize]="this.paginationAutoPageSize()"
    [rowHeight]="this.rowHeight"
    [rowSize]="this.rowSize()"
  ></cam-grid-table>
}

@if (this.displayType() === 'card' && this.cardTemplate(); as cardTemplate) {
  <div class="card-container">
    <ng-template
      [ngTemplateOutlet]="cardTemplate"
      [ngTemplateOutletContext]="{ items: this.filteredData$ | async }"
    ></ng-template>
  </div>
}

<div class="d-flex mt-space-md">
  <cam-grid-pagination class="align-center m-a" [gridId]="this.gridId()"></cam-grid-pagination>
</div>
